import { AfterViewInit, Component, DestroyRef, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { mapStyles } from '../../map-styles';
import { JoinOurCommunityService } from '@core/services/join-our-community.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
export const _LATITUDE =  41.161079;
export const _LONGITUDE = -104.805450;
interface Location {
  latitude: number;
  longitude: number;
  address: string;
  isComingSoon: boolean;
  name: string
}
declare const google:any;
@Component({
  selector: 'app-join-our-community-map',
  templateUrl: './join-our-community-map.component.html',
  styleUrls: ['./join-our-community-map.component.scss']
})
export class JoinOurCommunityMapComponent implements AfterViewInit, OnInit {
  readonly destroyRef = inject(DestroyRef);
  @ViewChild('mapContainer', { static: true }) mapContainer!: ElementRef;
  map:any;
  parkingLotDetails: any = [];
  openInfoWindow: any;
  comingSoonCount: number = 0;
  availableCount: number = 0;
  svgTemplate: string = '';

  constructor(
    private readonly joinOurCommunityService: JoinOurCommunityService
  ) { }

  ngOnInit() {
    fetch('assets/images/d_joinCommunitySvg.svg').then(res => res.text()).then(text => {
      this.svgTemplate = text; // store raw SVG string
    });
    setTimeout(()=>{
      this.getAllParkingLot();
    },1000);
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.loadMap();
    },1000);
  }

  getAllParkingLot() {
    let data = {
      pageNumber: 0,
      pageSize: 0
    }

    this.joinOurCommunityService.getAllParkingLot(data)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        for (const item of response.data) {
          const location = item.location;
          const locationObj: Location = {
            latitude: location.latitude,
            longitude: location.longitude,
            address: location.address,
            isComingSoon: item.isComingSoon,
            name: item.name
          };
          this.parkingLotDetails.push(locationObj);
          if(item.isComingSoon){
            this.comingSoonCount ++;
          }else{
          this.availableCount ++;
          }
        }
        this.loadMap();
      }, error: () => {

      }
    })
  }

  setMap(map): void {
    this.map = map;
  }

  loadMap(): void {
    const mapOptions= {
      center: { lat: _LATITUDE, lng: _LONGITUDE },
      zoom: 5,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: false,
      scrollwheel:true,
      styles: mapStyles,
    };
    const mapElement = this.mapContainer.nativeElement;
    this.map = new google.maps.Map(mapElement, mapOptions);
    this.setMap(this.map);
    if (this.parkingLotDetails && this.parkingLotDetails.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      this.parkingLotDetails.forEach((markerData) => {
        bounds.extend(
          new google.maps.LatLng(
            markerData?.latitude,
            markerData?.longitude
          )
        );
      });
      const listener = google.maps.event.addListenerOnce(
        this.map,
        'idle',
        () => {
          if (this.map.getZoom() > 15) {
            this.map.setZoom(15);
          }
        }
      );
      this.addMarkers(this.parkingLotDetails);
    }

  }

  addMarkers(markersData): void {
    if (markersData != undefined) {
      markersData.forEach((markerData) => {
        const isComingSoon = markerData.isComingSoon;

        if (!isComingSoon) {
          this.addMarkerWithFare(markerData);
        } else {
          this.addMarkerComingSoon(markerData);
        }
      });
    }
  }

  addMarkerWithFare(markerData) {
    const fareCharge = null;
    markerData.selectedFareCharge = fareCharge;
    const rectangleWidth = this.calculateRectangleWidth(fareCharge);
    const arrowPositionX = rectangleWidth / 2;
    const svgContent = this.createSvgContent(
      arrowPositionX,
      rectangleWidth,
      false,
    );
    const toolTipHTML = `<div class="tooltip-outer custom-tooltip join-tooltip">
    <div class="present-outer">
        <h4>${markerData.name}</h4>
        </div>
        <p class="court-outer">${markerData.address}</p>

        <div class="parking">`;
    this.createAndAddMarker(
      markerData,
      rectangleWidth,
      svgContent,
      true,
      toolTipHTML,
      fareCharge
    );
  }

  addMarkerComingSoon(markerData) {
    const comingsoonText = null;
    const rectangleWidth = this.calculateRectangleWidth(comingsoonText);
    const arrowPositionX = rectangleWidth / 2;
    const svgContent = this.createSvgContent(
      comingsoonText,
      arrowPositionX,
      rectangleWidth,
      true
    );
    const toolTipHTML = `<div class="tooltip-outer custom-tooltip join-tooltip">
    <div class="present-outer">
        <h4>${markerData?.name}</h4>
        </div>
        <p class="court-outer">${markerData?.address}</p>

        <div class="parking">`
    this.createAndAddMarker(
      markerData,
      rectangleWidth,
      svgContent,
      false,
      toolTipHTML,
      comingsoonText
    );
  }

  calculateRectangleWidth(text) {
    const textWidth = this.calculateTextWidth(text);
    return textWidth + 30;
  }

   createSvgContent(_arrowPositionX, rectangleWidth, isComingSoon, _isEntireParkingUndermaintenance = null) {
    const translateX = rectangleWidth / 2;
    let markerIconColor;
    if (isComingSoon) {
      markerIconColor = '#C16725';
    } else {
      markerIconColor = '#2AA571';
    }


    const replacedSvg = this.svgTemplate
      .replace(/{{rectangleWidth}}/g, (rectangleWidth + 8).toString())
      .replace(/{{translateX}}/g, (translateX - 10).toString())
      .replace(/{{translateX_16}}/g, (translateX - 16).toString())
      .replace(/{{markerIconColor}}/g, markerIconColor);

    // turn into base64 so Google Maps marker accepts it
    return replacedSvg;
  }
  createAndAddMarker(
    markerData,
    rectangleWidth,
    svgContent,
    markerClickable,
    tooltipHTML,
    _marketText
  ) {
    const svgIconUrl = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgContent)}`;
    const restStopIcon = {
      url: svgIconUrl,
      scaledSize: new google.maps.Size(rectangleWidth, 50),
      labelOrigin: new google.maps.Point(rectangleWidth / 2 + 4, 50)
    };
    const marker = new google.maps.Marker({
      position: {
        lat: markerData?.latitude,
        lng: markerData?.longitude,
      },
      map: this.map,
      icon: restStopIcon,
      zIndex: 1000 - Math.round(markerData?.latitude * 1000000),
      clickable: true
    });
    const infowindow = new google.maps.InfoWindow({
      content: tooltipHTML || null,
      maxWidth: 250,
    });
    this.openInfoWindow=new google.maps.InfoWindow();
    const handleMarkerClick = () => {

      if (this.openInfoWindow) {
        this.openInfoWindow.close();
      }
      infowindow.open(this.map, marker);
      this.openInfoWindow = infowindow;
      this.setCloseButtonClass();
    };
    if (markerClickable) {
      marker.addListener('click', () => {
        if (tooltipHTML !== '') {
          handleMarkerClick();
        }
      });
    } else if (tooltipHTML) {
      marker.addListener('click', handleMarkerClick);
    }

    google.maps.event.addListener(this.map, 'click', () => {
      if (this.openInfoWindow) {
        this.openInfoWindow.close();
        this.openInfoWindow = null;
      }
    });
  }

  setCloseButtonClass(): void {
    setTimeout(() => {
      const infoWindowContainer = document.querySelector('.gm-style-iw');
      infoWindowContainer.classList.add('custom-tooltip');
      const closeButton = infoWindowContainer?.querySelector(
        '.gm-ui-hover-effect'
      );

      if (closeButton) {
        closeButton.classList.add('custom-close-button');
      }
    }, 100);
  }

  calculateTextWidth(text: string): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = '24px Arial';
      return context.measureText(text).width;
    }
    return 0;
  }
}
